import React, { useState } from "react";
import Button from "components/CustomButton";
import { useToasts } from "react-toast-notifications";
import Loader from "components/Loader";
import TeamService from "services/TeamService";
import { Modal } from "react-responsive-modal";

const useStyles = {
  deleteButton: {
    paddingTop: "15px",
    display: "flex",
    justifyContent: "center",
  },
};

export default ({ team, setSlackData, setSlackErrorMessage }) => {
  const classes = useStyles;
  const { addToast } = useToasts();
  const [confimDisconnectSlack, setConfirmDisconnectSlack] = useState(false);
  const [disableButton, setDisableButton] = useState(false);

  const disconnectSlack = async () => {
    try {
      setDisableButton(true);
      var response = await TeamService.deleteUserSlackInformation(team.id);

      setSlackData(response.data.data);
      setSlackErrorMessage("There is no slack configuration found");
      addToast("You have been disconnect from the slack.", {
        appearance: "success",
      });
      setConfirmDisconnectSlack(false);
      setDisableButton(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div style={classes.deleteButton}>
        <Button
          buttonClass={"grad_btn join-btn"}
          name={
            !disableButton ? (
              " Disconnect Slack"
            ) : (
              <Loader width={40} height={40} />
            )
          }
          disabled={disableButton && true}
          onClick={() => setConfirmDisconnectSlack(true)}
        />
      </div>
      <Modal
        open={confimDisconnectSlack}
        onClose={() => setConfirmDisconnectSlack(false)}
        showCloseIcon={false}
        classNames={{ modalContainer: "modalContainer", modal: "slackModal" }}
      >
        <div className="modalHeader">Slack Confirmation</div>
        <div className="modalContent">
          Do you want to disconnect from the slack?
        </div>
        <div className="modalAction">
          <Button
            disabled={disableButton && true}
            onClick={() => {
              setConfirmDisconnectSlack(false);
            }}
            buttonClass="small-btn me-2"
          >
            Cancel
          </Button>
          <Button
            disabled={disableButton && true}
            buttonClass=" small-reject-btn "
            onClick={disconnectSlack}
            name={
              !disableButton ? " Confirm" : <Loader width={25} height={25} />
            }
          />
        </div>
      </Modal>
    </>
  );
};
